import React, { useEffect, useReducer } from "react";
import "./XeesterApp.scss";
import Div100vh from "react-div-100vh";
import Login from "../app/login/Login";
import DatabaseManagementDialog from "../app/backup/DatabaseManagementDialog";
import CoBrowse from "../app/cobrowse/CoBrowse";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import ReactScrollWheelHandler from "react-scroll-wheel-handler";

import XeesterNavigationBar from "./navigation/navigationbar/XeesterNavigationBar";
import { HudReducer, HUD_ACTIONS } from "./hud-profiles/state/HudReducer";
import { HudContext } from "./hud-profiles/state/HudContext";
import HudState from "./hud-profiles/state/HudState";
import StatisticDefinitionsFakeData from "./hud-profiles/state/StatisticDefinitionsFakeData.json";
import StatisticTranslationsFakeData from "./hud-profiles/state/StatisticTranslationsFakeData.json";
import SessionList from "./sessions/SessionList";
import HandList from "./hands/HandList";
import AppReplayer from "./replayer/AppReplayer";
import { poktoolsReducer } from "./poktools/poktoolsReducer";
import PoktoolsState from "./poktools/PoktoolsState";
import { PoktoolsContext } from "./poktools/poktoolsContext";
import Poktools from "./poktools/Poktools";

import { SessionReducer } from "./sessions/state/SessionReducer";
import SessionState from "./sessions/state/SessionState";
import { SessionContext } from "./sessions/state/SessionContext";
import { sendCommand } from "./components/Bridge";
import "react-contexify/dist/ReactContexify.css";
import { AppReducer } from "./state/AppReducer";
import { AppContext } from "./state/AppContext";
import AppState from "./state/AppState";

function XeesterApp({history}) {

  const [appState, dispatchAppState] = useReducer(AppReducer, new AppState());
  const [hudsState, dispatchHudsState] = useReducer(HudReducer, new HudState());

  
  const [poktoolsState, dispatchPoktoolsState] = useReducer(
    poktoolsReducer,
    new PoktoolsState()
  );
  const [sessionState, dispatchSessionState] = useReducer(
    SessionReducer,
    new SessionState()
  );

  const historyPush= (url)=>{
    console.log("historyPush", url);
    history.push(url);
  }

  window.historyPush = historyPush;

  useEffect(() => {
    console.log("navopen", appState.navigationOpen);
    let listener = (e) => {
      e.preventDefault();
    }
    document.addEventListener('contextmenu', listener);

    if (window.statisticBridge) {
      let definitions = JSON.parse(
        window.statisticBridge.getStatisticDefinitions()
      );
      dispatchHudsState({
        type: HUD_ACTIONS.STATISTIC_DEFINITIONS_UPDATED,
        payload: definitions
      });
      //console.log(window.statisticBridge.getStatisticDefinitions());
      let translations = JSON.parse(window.statisticBridge.getTranslations());
      dispatchHudsState({
        type: HUD_ACTIONS.STATISTIC_TRANSLATIONS_UPDATED,
        payload: translations
      });
    } else {
      let definitions = StatisticDefinitionsFakeData;
      dispatchHudsState({
        type: HUD_ACTIONS.STATISTIC_DEFINITIONS_UPDATED,
        payload: definitions
      });
      let translations = StatisticTranslationsFakeData;
      dispatchHudsState({
        type: HUD_ACTIONS.STATISTIC_TRANSLATIONS_UPDATED,
        payload: translations
      });
    }
    return () => {
      document.removeEventListener('contextmenu', listener);
      console.log("XeesterApp effect done");
    };
  }, [appState.navigationOpen]);

  return (
    <ReactScrollWheelHandler
      timeout={100}
      preventScroll={true}
      upHandler={(e) => {
        if (e && e.ctrlKey) {
          console.log("scroll up", e);
          sendCommand("gui/zoomIn");
        }
      }}
      downHandler={(e) => {
        if (e && e.ctrlKey) {
          console.log("scroll down", e);
          sendCommand("gui/zoomOut");
        }
      }}
    >

    <AppContext.Provider value={{ appState, dispatchAppState }}>
      <PoktoolsContext.Provider value={{ poktoolsState, dispatchPoktoolsState }}>
        <SessionContext.Provider value={{ sessionState, dispatchSessionState }}>
          <Switch>
            <Route
              path="/app/login"
              render={(props) => <Login {...props}></Login>}
            />
            <Route
              path="/app/replayer/"
              render={(props) => <AppReplayer {...props} />}
            />
            <Route
              path="/app/poktools/:tool"
              render={(props) => <Poktools {...props}></Poktools>}
            />
            <Route
              path="/app/content/"
              render={(props) => (
                <>
                  <HudContext.Provider value={{ hudsState, dispatchHudsState }}>
                    <Div100vh
                      id="xeester-app"
                      className={(appState.navigationOpen?"nav-open":"")+(appState.navigationManualClosed?" nav-manual-closed":"")}
                      >
                      <Route
                        path="/app/content/:money/:sessionType/:hero/:moduleType/:nodeId/:sort/:dir"
                        render={(props) => (
                          <XeesterNavigationBar {...props}></XeesterNavigationBar>
                        )}
                      />
                      <Switch>
                        <Route
                          path="/app/content/:money/:sessionType/:hero/:moduleType"
                          render={(props) => (
                            <>
                              <Switch>
                                <Route
                                  path="/app/content/:money/:sessionType/:hero/session/:nodeId/:sort/:dir"
                                  render={(props) => (
                                    <SessionList
                                      {...props}
                                    />
                                  )}
                                />

                                <Redirect
                                  path="/app/content/:money/:sessionType/:hero/session"
                                  to="/app/content/:money/:sessionType/:hero/session/0/date/desc"
                                  exact
                                />
                                <Route
                                  render={(props) => (
                                    <SessionList
                                      {...props}
                                    />
                                  )}
                                />
                              </Switch>
                              <Route
                                path="/app/content/:money/:sessionType/:hero/hand"
                                render={(props) => <HandList {...props} />}
                              />
                            </>
                          )}
                        />
                      </Switch>
                    </Div100vh>
                  </HudContext.Provider>
                  <CoBrowse />
                  <DatabaseManagementDialog />
                </>
              )}
            />
          </Switch>
        </SessionContext.Provider>
      </PoktoolsContext.Provider>
    </AppContext.Provider>
    </ReactScrollWheelHandler>
  );
}
export default withRouter(XeesterApp);
